import axios from "axios";

import * as actionTypes from "../actionTypes";
import * as constants from "../../../Data/constants";
import { Encrypt } from "containers/Login/AESHandler";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
}

export const authSuccess = (response_data, list, routes) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    props: response_data,
    entity_list: list,
    entity_routes_match: routes
  }
}

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_ERROR,
    error: error
  }
}

export const authLogout = () => {
  const themeInfo = localStorage.getItem(constants.THEME_CONTROLLER);
  localStorage.clear();
  localStorage.setItem(constants.THEME_CONTROLLER, themeInfo);
  
  return {
    type: actionTypes.AUTH_LOGOUT
  }
}
// Added by Vaibhav
export const authLogoutV2 = () => {
  const themeInfo = localStorage.getItem(constants.THEME_CONTROLLER);
  // localStorage.clear();
  localStorage.setItem(constants.THEME_CONTROLLER, themeInfo);
  
  return {
    type: actionTypes.AUTH_LOGOUT
  }
}
///

export const checkAuthTimeout = () => {
  return dispatch => {
    setTimeout(() => {
      dispatch(authLogout())
    }, 300000 * 1000);
  }
}
export const auth = (email, password, history, authFailCB, prevPage) => {
  return dispatch => {
    dispatch(authStart());
    // dispatch(authLogout());
    const loginData = {
      email: email,
      password: password
    }
    console.log("rolessss===>",{loginData})
    // Removing token from headers, if it is present 
    // either a token or null, server will respond with 401
    axios.defaults.headers.common.Authorization = ''

    axios.post(`/api/users/org_users/login`, loginData)
      .then(response => {
        let role = response.data.data.roles[0].name
        console.log("rolessss===>",role)
        localStorage.setItem("userRole",role)
        axios.defaults.headers.common.Authorization = `JWT ${response.data.token}`;
        if(!prevPage) {
          axios.get(`/api/apps/?is_global=true`).then(data => {
            if ( data.data.data && data.data.data.length !== 0) {
              if(window.location.pathname === '/org/login' || window.location.pathname === '/org/' || window.location.pathname === '/org') {
                history.push({
                  pathname: '/process_okaygo',
                  search: window.location.search
                });
              }
            } else {
              history.push({
                pathname: '/workflows/add',
                search: window.location.search
              });
            }
          }).catch(err => {
            // eslint-disable-next-line no-console
          })
        }
        
        let expirationDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
        expirationDate.setUTCSeconds(response.data.token_expiration);
        
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("username", response.data.first_name);
        localStorage.setItem("expirationDate", expirationDate);
        localStorage.setItem("email", response.data.data.id);
        localStorage.setItem("userEmail", Encrypt(response.data.data.email));
        localStorage.setItem("userId", response.data.data.id);

        
        let response_data = {
          'token': response.data.token,
          'username': response.data.data.email,
          'id': response.data.data.id,
          'groupId': response.data.data.roles[0].id,
          'groupName': response.data.data.roles[0].name,
          'firstName': response.data.data.first_name,
          'lastName': response.data.data.last_name,
          'employeeId': response.data.data.employee_id,  
          'uiPermissions': response.data.data.ui_permissions,
          'manager': response.data.data.manager,
          "involved_groups" : response.data.data.involved_groups,
          'uiFeatures': response.data.data.ui_features,
          'processFilter': response.data.data.process_filter,
          'current_task_owner' :response.data.data,
          'notificationSupport': response.data.data.support_notification,
          'dashboardView': response.data.data.dashboard_view,
          'entity_list':[],
          'entity_routes_match': [],
          partner: response.data.data.partner,
        }
        let uiPermissions = response.data.data.ui_permissions;
        if (uiPermissions.masterrecords.manage) {
          axios.get('/api/entity/master').then((entity)=>{
            let list = entity.data.data.filter(master=> master.model_type === "entities")
            let entity_list =list && list.map((item) => {
              let entity_search_fields = [];
              if(item.search_fields && item.keyvaluepair) {
                entity_search_fields = item.search_fields
                .filter(field => item.keyvaluepair[field])
                .map((field) => {
                    if(item.keyvaluepair[field]) {
                      return {
                        id: field,
                        name: item.keyvaluepair[field]
                      }
                    }
                    return null;
                  });
                }
              return {
                  "displayName" : item.name,
                  "id" : item.name,
                  "url" :`/entity/${item.id}`,
                  "appClass" : "icon-id",
                  "show" : item.view_permission,
                  "feature": true,
                  entity_search_fields,
                  "master_model_id":item.id,
                  "bulk_update_permission":item.bulk_update_permission,
              }
            })        
            let entity_routes_match = list.map((e)=> new RegExp(`entity/${e.id}`))
            dispatch(authSuccess(response_data, entity_list, entity_routes_match))
            
          })
        }
        dispatch(authSuccess(response_data, [], []));
        dispatch(checkAuthTimeout(response.data.token_expiration));
      })
      .catch(err => {
        authFailCB(err.response.data.message)
        dispatch(authFail(err.response.data.message));
      });
  }
}


export const authCheckState = (CB) => {
  return dispatch => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    if (!token) {
      dispatch(authLogout());
      CB()
    } else {
      const expirationDate = new Date(localStorage.getItem('expirationDate'));
      if (expirationDate <= new Date()) {
        dispatch(authLogout());
        CB()
      } else {
        axios.defaults.headers.common.Authorization = `JWT ${token}`;
        axios.get(`/api/users/org_users/${userId}`).then(response=>{
          let uiPermissions = response.data.data.ui_permissions;
          let response_data = {
            'token': token,
            'username': response.data.data.email,
            'id': response.data.data.id,
            'groupId': response.data.data.roles[0].id,
            'groupName': response.data.data.roles[0].name,
            'firstName': response.data.data.first_name,
            'lastName': response.data.data.last_name,  
            'employeeId': response.data.data.employee_id,
            'uiPermissions': response.data.data.ui_permissions,
            'manager' : response.data.data.manager,
            "involved_groups" : response.data.data.involved_groups,
            'uiFeatures': response.data.data.ui_features,
            'processFilter': response.data.data.process_filter,
            'current_task_owner' : response.data.data,
            'notificationSupport': response.data.data.support_notification,
            'profilePhoto': response.data.data.display_picture,
            'dashboardView': response.data.data.dashboard_view,
            'entity_list':[],
            'entity_routes_match': [],
            partner: response.data.data.partner,
          }
          if (uiPermissions.masterrecords.manage) {
            axios.get('/api/entity/master').then((entity)=>{
              let list = entity.data.data.filter(master=> master.model_type === "entities")
              let entity_list =list && list.map((item) => {
                let entity_search_fields = [];
                if(item.search_fields && item.keyvaluepair) {
                  entity_search_fields = item.search_fields
                  .filter(field => item.keyvaluepair[field])
                  .map((field) => {
                      if(item.keyvaluepair[field]) {
                        return {
                          id: field,
                          name: item.keyvaluepair[field]
                        }
                      }
                      return null;
                    });
                  }
                return {
                    "displayName" : item.name,
                    "id" : item.name,
                    "url" :`/entity/${item.id}`,
                    "appClass" : "icon-id",
                    "show" : item.view_permission,
                    "feature": true,
                    entity_search_fields,
                    "master_model_id":item.id,
                    "bulk_update_permission":item.bulk_update_permission,
                }
              })        
              let entity_routes_match = list.map((e)=> new RegExp(`entity/${e.id}`))
              dispatch(authSuccess(response_data, entity_list, entity_routes_match))
              
            })
          }
          
          // Each time page refresh
          // We will set the all the reponses 
          dispatch(authSuccess(response_data, [], []))
          CB()
        })
        .catch(() => {
          dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000));
          CB()
        })

      }
    }
  };
};
